import { render } from "./Home.vue?vue&type=template&id=5f5fe728&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=5f5fe728&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2221027770/src/vedicastrologyreport-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5fe728"]])

export default __exports__